import React from 'react';
import ScaleInput from '..';
import StarONIcon from './star-on.svg';
import StarOFFIcon from './star-off.svg';

function ScaleInputStars(props) {
    const { ...otherProps } = props;

    return <ScaleInput {...otherProps} IconON={StarONIcon} IconOFF={StarOFFIcon} />;
}

export default ScaleInputStars;
